import { getThemeColors } from "../lib/theme";

interface StatCardProps {
  label: string;
  value: string;
  isDark: boolean;
  delay?: number;
  truncate?: boolean;
}

export function StatCard({
  label,
  value,
  isDark,
  delay = 0,
  truncate = false,
}: StatCardProps) {
  const theme = getThemeColors(isDark);

  return (
    <div
      className={`min-w-0 p-5 ${theme.panel} flex flex-col items-center justify-center text-center`}
      style={{ animationDelay: `${delay * 100}ms` }}
    >
      <div
        className={`font-display text-2xl sm:text-3xl ${theme.text} ${truncate ? "truncate max-w-full" : ""}`}
      >
        {value}
      </div>
      <div
        className={`font-display text-[11px] uppercase tracking-wider mt-2 ${theme.textMuted}`}
      >
        {label}
      </div>
    </div>
  );
}
